export default __webpack_public_path__ + "static/media/bg22.7c0d9d22.png";